import { Field } from 'react-final-form';
import Checkbox from '@guestyci/foundation/Checkbox';
import TextField from '@guestyci/foundation/TextField';

interface ICheckboxUIProps {
  name: string;
  label: string;
}

export default function CheckboxUI({ name, label }: ICheckboxUIProps) {
  return (
    <Field
      type="checkbox"
      name={name}
      render={({ input }) => (
        <Checkbox
          checked={input.checked}
          onChange={input.onChange}
          value={name}
          name={name}
        >
          <TextField color="dark">{label}</TextField>
        </Checkbox>
      )}
    />
  );
}
